import FuelTakenPage from './fuel-taken';

export default FuelTakenPage;